<!--项目看板 -->
<template>
  <div class="information">
    <div class="ProjectTop">
      <div class="establish"
           @click="gotoTransfer(1)">
        <div class="left">
          <div class="image">
            <img src="@/assets/images/add.png"
                 alt=""
                 class="img">
          </div>
        </div>
        <div class="right">
          <div class="title"> 创建项目</div>
          <div class="text">快速创建新的NSR项目</div>
        </div>
      </div>
      <div class="analyse"
           @click="gotoAllProjectAnalysis()">
        <div class="left">
          <img src="@/assets/images/analyse.png"
               alt=""
               class="img">
        </div>
        <div class="right">
          <div class="title"> 所有项目详情</div>
          <div class="text">对已有项目进行数据分析与结果下载</div>
        </div>
      </div>

    </div>
    <el-card class="box-card">
      <!-- 切换 -->
      <el-tabs v-model="activeName"
               @tab-click="handleClick">
        <el-tab-pane label="全部项目"
                     name="allProjects">
        </el-tab-pane>
        <el-tab-pane label="可分析项目"
                     name="analysable">
        </el-tab-pane>
        <el-tab-pane label="已分析项目"
                     name="Analyzed"></el-tab-pane>
        <el-tab-pane label="待上传项目"
                     name="undetermined">
        </el-tab-pane>
      </el-tabs>

      <!-- 表格 -->
      <el-table :data="projectList"
                style="width: 100%"
                @row-dblclick="onRowDblClick">
        <el-table-column prop="name"
                         label="项目名称">
          <template slot-scope="scope">
            <i class="el-icon-folder"></i>
            <span style="margin-left: 10px">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime"
                         label="创建时间">
        </el-table-column>
        <el-table-column prop="startTime"
                         label="开始时间">
        </el-table-column>
        <el-table-column prop="endTime"
                         label="结束时间">
        </el-table-column>
        <el-table-column prop="introduction"
                         label="简介">
        </el-table-column>
        <el-table-column prop="status"
                         label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status==3?'success':scope.row.status==2?'warning':scope.row.status==1?'info':scope.row.status==0?'info':''">
              {{scope.row.status==3?'已分析':scope.row.status==2?'待分析':scope.row.status==1?'未上传':scope.row.status==0?'未上传':'未知'}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作"
                         align="center"
                         width="250px">
          <template v-slot="{row}">
            <el-button-group>
              <el-button type="success"
                         size="mini"
                         icon="el-icon-upload2"
                         @click.stop="gotoTransfer(2,row.id)"
                         @dblclick.stop></el-button>
              <el-button type="info "
                         size="mini"
                         icon="el-icon-folder-checked"
                         @click.stop="gotoTransfer(3,row.id)"
                         @dblclick.stop></el-button>
              <el-button type="warning"
                         size="mini"
                         icon="el-icon-view"
                         @click.stop="gotoProjectAnalysis(row)"
                         @dblclick.stop></el-button>
              <el-button type="primary"
                         size="mini"
                         icon="el-icon-edit"
                         @click.stop="openEditDialog(row)"
                         @dblclick.stop></el-button>
              <el-button type="danger"
                         size="mini"
                         icon="el-icon-delete"
                         @click.stop="delDialog(row)"
                         @dblclick.stop></el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页导航 -->
      <template>
        <el-row class="pagination">
          <pagination :total="total"
                      :page.sync="queryParams.pageNum"
                      :limit.sync="queryParams.pageSize"
                      @pagination="getProjectList" />
        </el-row>
      </template>

      <!-- 修改项目 -->
      <el-dialog :visible.sync="editProjectDialogVisible"
                 width="80%"
                 :show-close=false>
        <div class="createProject">
          <div class="title">修改项目信息</div>
          <!-- <div class="text">修改项目基本信息开始您的工作</div> -->
        </div>
        <el-form label-position="top"
                 :rules="editRules"
                 ref="editRuleForm"
                 :inline="true"
                 label-width="80px"
                 :model="editProjectList">
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目名称"
                            prop="name"
                            style="width:95%">
                <el-input v-model="editProjectList.name"
                          placeholder="请输入项目名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开始时间"
                            style="width:95%">
                <el-date-picker v-model="editProjectList.startTime"
                                type="month"
                                style="width: 100%;"
                                placeholder="-/-">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结束时间"
                            style="width:95%">
                <el-date-picker v-model="editProjectList.endTime"
                                type="month"
                                style="width: 100%;"
                                placeholder="-/-">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="项目备注"
                        style="display: block;">
            <el-input type="textarea"
                      placeholder="请输入项目相关备注信息（选填）"
                      v-model="editProjectList.introduction"
                      maxlength="500"
                      show-word-limit>
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click="editProjectDialogVisible=false">取 消 修 改</el-button>
          <el-button style="background-color: #145fad; color: white; border-color: #fff;"
                     @click="editProject('editRuleForm')">修 改 项 目</el-button>
        </span>
      </el-dialog>

      <!-- 项目详情 -->
      <el-dialog :visible.sync="projectDetailsDialogVisible"
                 title="项目详情"
                 width="30%">
        <el-form label-position="top"
                 label-width="80px"
                 :model="projectDetailsList">
          <el-form-item label="项目名称"
                        style="display: block;">
            <el-input v-model="projectDetailsList.name"
                      placeholder="请输入项目名称"></el-input>

          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="起始月份"
                            style="width:95%">
                <el-date-picker v-model="projectDetailsList.begin"
                                type="month"
                                style="width: 100%;"
                                placeholder="-/-">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="终止月份"
                            style="width:95%">
                <el-date-picker v-model="projectDetailsList.finish"
                                type="month"
                                style="width: 100%;"
                                placeholder="-/-">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <span slot="footer"
              class="dialog-footer">
          <el-button icon="el-icon-upload2"
                     style="background-color: #145fad; color: white; border-color: #fff;"
                     @click="gotoTransfer(2,projectDetailsList.projectId)">上传项目文件</el-button>
        </span>
      </el-dialog>
    </el-card>

    <!-- 图表 -->
    <el-card class="box-card">
      <div>
        <h1>项目进度分布</h1>
        <div id="main"
             ref="mainChart"
             style="width: 100%; height: 500px;"></div>
        <!-- 这里可以添加界面元素，用于修改图表配置 -->
      </div>
    </el-card>
  </div>
</template>

<script>
// 引入echarts
import echarts from 'echarts'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      editProjectDialogVisible: false,
      projectDetailsDialogVisible: false,

      projectDetailsList: {
        name: '',
        begin: '',
        finish: '',
        remark: '',
        projectId: ''
      },
      editProjectList: {
        projectId: '',
        name: '',
        startTime: '',
        endTime: '',
        introduction: ''
      },
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        keyword: '',
        type: 0
      },
      total: 126,
      projectList: [],
      activeName: 'allProjects',
      chartInstance: null,

      editRules: {
        name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }]
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
      window.addEventListener('resize', this.handleChartResize)
    })
    this.setStateFromRoute()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleChartResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  },
  methods: {
    // 柱状图
    initChart() {
      const chartDom = this.$refs.mainChart || document.getElementById('main')
      if (!chartDom) return
      if (this.chartInstance) {
        this.chartInstance.dispose()
        this.chartInstance = null
      }
      this.chartInstance = echarts.init(chartDom)

      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} :  {d}%'
        },
        legend: {
          orient: 'vertical',
          right: 10,
          top: 20,
          bottom: 20
        },
        series: [
          {
            name: '项目名称',
            type: 'pie',
            radius: '50%',
            data: [
              { value: 96.1, name: '已分析项目', itemStyle: { color: '#ed7310' } },
              { value: 1.3, name: '待上传项目', itemStyle: { color: '#834bf1' } },
              { value: 2.6, name: '可分析项目', itemStyle: { color: '#1b48ae' } }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      // 设置图表的配置项
      this.chartInstance.setOption(option)
      this.$nextTick(() => {
        if (this.chartInstance) this.chartInstance.resize()
      })
    },
    handleChartResize() {
      if (this.chartInstance) this.chartInstance.resize()
    },
    handleClick(tab, event) {
      if (tab.name == 'Analyzed') {
        this.queryParams.type = 3
      } else if (tab.name == 'undetermined') {
        this.queryParams.type = 1
      } else if (tab.name == 'analysable') {
        this.queryParams.type = 2
      } else {
        this.queryParams.type = 0
      }
      this.queryParams.pageNum = 1
      this.getProjectList(this.queryParams.type)
      // if (tab.name == 'undetermined') {
      //   this.projectDetailsDialogVisible = true
      // }
    },
    mapTypeToActiveName(type) {
      const t = Number(type)
      if (t === 3) return 'Analyzed'
      if (t === 1) return 'undetermined'
      if (t === 2) return 'analysable'
      return 'allProjects'
    },
    mapActiveNameToType(name) {
      if (name === 'Analyzed') return 3
      if (name === 'undetermined') return 1
      if (name === 'analysable') return 2
      return 0
    },
    setStateFromRoute() {
      const q = this.$route.query || {}
      const tab = q.tab
      const page = Number(q.page)
      if (tab) {
        this.activeName = tab
        this.queryParams.type = this.mapActiveNameToType(tab)
      }
      if (!Number.isNaN(page) && page > 0) {
        this.queryParams.pageNum = page
      }
      this.getProjectList(this.queryParams.type)
    },
    openUploadingDialogBox(row) {
      this.projectDetailsDialogVisible = true
      this.projectDetailsList.projectId = row.id
      this.projectDetailsList.name = row.name
    },
    gotoProjectAnalysis(row) {
      this.$router.push({
        path: '/projectAnalysis',
        query: {
          name: row.name,
          projectId: row.id,
          tab: this.activeName,
          page: this.queryParams.pageNum
        }
      })
    },
    onRowDblClick(row, column, event) {
      this.gotoProjectAnalysis(row)
    },
    gotoAllProjectAnalysis() {
      this.$router.push({ path: '/projectAnalysis' })
    },
    isTruthy(v) {
      return v === true || v === 'true' || v === 1 || v === '1'
    },
    isFileLinked(row) {
      const r = row || {}
      if (typeof r.fileAssociated !== 'undefined') return this.isTruthy(r.fileAssociated)
      if (typeof r.hasFile !== 'undefined') return this.isTruthy(r.hasFile)
      if (typeof r.fileLinked !== 'undefined') return this.isTruthy(r.fileLinked)
      if (typeof r.hasOriginalFile !== 'undefined') return this.isTruthy(r.hasOriginalFile)
      if (typeof r.hasTableFile !== 'undefined') return this.isTruthy(r.hasTableFile)
      if (typeof r.fileCount !== 'undefined') return Number(r.fileCount) > 0
      if (typeof r.fileId !== 'undefined') return !!r.fileId
      if (typeof r.originalFileId !== 'undefined') return !!r.originalFileId
      return false
    },
    // 获取项目列表
    async getProjectList(type) {
      if (typeof type === 'number' || typeof type === 'string') {
        const nextType = Number(type)
        if (!Number.isNaN(nextType)) {
          this.queryParams.type = nextType
        }
      }
      const { data: res } = await this.$http.post('/brain/project/getProjectList', this.queryParams)
      this.projectList = res.data.list
      this.total = res.data.total
    },

    // 删除对话框
    delDialog(row) {
      this.$confirm(`此操作将删除${row.name}, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delProject(row.id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 确认删除
    async delProject(projectId) {
      const { data: res } = await this.$http.get('/brain/project/delProject', { params: { projectId: projectId } })
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.getProjectList()
      } else {
        this.$message.error(res.msg)
      }
    },
    openEditDialog(row) {
      this.editProjectList.projectId = row.id
      this.editProjectList.name = row.name
      this.editProjectList.startTime = row.startTime
      this.editProjectList.endTime = row.endTime
      this.editProjectList.introduction = row.introduction
      this.editProjectDialogVisible = true
    },
    // 编辑项目
    editProject(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post('/brain/project/modifyProject', this.editProjectList)
          if (res.code == 200) {
            this.$message({
              message: '修改项目成功',
              type: 'success'
            })
            this.getProjectList()
          } else {
            this.$message.error(res.msg)
          }
          this.editProjectDialogVisible = false
        } else {
          return false
        }
      })
    },
    // 打开中转页面
    gotoTransfer(type, projectId) {
      this.$router.push({
        path: '/transfer',
        query: {
          type: type,
          projectId: projectId,
          from: 'managementItem',
          tab: this.activeName,
          page: this.queryParams.pageNum
        }
      })
    }
  }
}
</script>
<style lang='scss' scoped>
.information {
  width: 100%;
  height: 100%;
  .ProjectTop {
    display: flex;
    padding: 10px;
    justify-content: space-between;
    .establish {
      width: 49%;
      display: flex;
      background-color: #e2ebf4;
      border-radius: 10px;
      padding: 25px 20px;
      .left {
        width: 50px;
        height: 50px;
        background-color: #1962ae;
        border-radius: 10%;
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
        .image {
          width: 20px;
          height: 20px;
          background-color: #fff;
          border-radius: 100%;
          display: flex;
          justify-content: center; /* 水平居中 */
          align-items: center;
          .img {
            max-width: 70%; /* 保证图片不会超出容器 */
            height: auto; /* 保持图片比例 */
          }
        }
      }
      .right {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .title {
          font-weight: 600;
        }
        .text {
          font-size: 12px;
          color: #89909d;
        }
      }
    }
    .analyse {
      width: 49%;
      display: flex;
      background-color: #f8f0e5;
      border-radius: 10px;
      padding: 20px;
      .left {
        width: 50px;
        height: 50px;
        background-color: #f08a19;
        border-radius: 10%;
        display: flex;
        justify-content: center; /* 水平居中 */
        align-items: center; /* 垂直居中 */
        .img {
          width: 50%;
        }
      }
      .right {
        padding-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .title {
          font-weight: 600;
        }
        .text {
          font-size: 12px;
          color: #89909d;
        }
      }
    }
  }
  .createProject {
    text-align: center;
    .title {
      font-weight: 600;
      font-size: 20px;
      color: #1962af;
    }
    .text {
      margin-top: 10px;
      color: #9097a0;
    }
  }
  .el-dialog__header {
    padding: 0px;
  }
  .box-card {
    margin-top: 20px;
    border-radius: 10px;
  }
}
</style>
